<template>
  <div>
    <div class="card dashcard mb-0">
      <div class="card-body">
        <div class="form-row">
          <div class="col col-12 col-md-6">
            <az-periodo v-model="filtro" :sync="true" @sync="load()" />
          </div>
          <div class="col col-12 col-md-2">
            <az-input
              type="select"
              icon="fa fa-calendar-o fa-fw"
              placeholder="Baixa"
              :optionsList="[
                { id: 'V', search: 'Vencimento' },
              ]"
              optionsData="id"
              optionsDisplay="search"
              v-model="tipo_data">
            </az-input>
          </div>
          <div class="col col-12 col-md-2">
            <az-input
              type="select"
              icon="fas fa-funnel-dollar"
              placeholder="Todos..."
              optionsData="id"
              :optionsList="[
                { id: 'C', search: 'Recebido'},
                { id: 'D', search: 'Pago'},
                { id: 'T', search: 'Transferência'},
                { id: 'M', search: 'Adiantamentos'},
                { id: 'A', search: 'Adiant. de Paciente'},
              ]"
              v-model="filtro.natureza"
            />
          </div>
          <div class="col col-12 col-md-2">
            <az-input
              type="select"
              icon="fas fa-tasks"
              placeholder="Todos..."
              optionsData="id"
              :optionsList="[{ id: 'C', search: 'Conciliados'}, { id: 'N', search: 'Não Conciliados'}]"
              v-model="filtroExibicao.conciliacao"
            />
          </div>
        </div>

        <div class="form-row mt-2">
          <div class="col col-12 col-md-2">
            <az-input
              placeholder="Todas as Contas..."
              icon="fas fa-money-check-alt"
              type="select"
              optionsMode="aql"
              service="contas.index"
              optionsName="contas.index.classe"
              optionsData="id_conta"
              optionsDisplay="search"
              :optionsParm="{ ativas: true, classificacao: true }"
              v-model="filtro.id_conta"
            />
          </div>
          <div class="col col-12 col-md-2">
            <az-input
              icon="fa fa-filter"
              type="select"
              :optionsList="[
                { id: 'L', search: 'Unid. do Lançamento' },
                { id: 'C', search: 'Unid. da Conta' },
              ]"
              :edicao="filtro.id_unidade_operacao ? true : false"
              optionsData="id"
              v-model="filtro.tipo_filtro_unidade" />
          </div>

          <div class="col col-12 col-md-2">
            <az-input
              type="checkbox-group"
              label="Baixa Múltipla Consolidada"
              v-model="filtro.consolidado" />
          </div>

          <div class="col col-12 col-md-3">
            <az-input
              :edicao="!$store.state.user.id_unidade_operacao"
              icon="far fa-building fa-fw"
              type="select"
              placeholder="Todas"
              :optionsList="$util.unidades_com_tags(true, true)"
              optionsData="id_unidade_operacao"
              v-model="filtro.id_unidade_operacao" />
          </div>

          <div class="col col-12 col-md-3">
            <az-input
                icon="fas fa-funnel-dollar fa-fw"
                type="select"
                placeholder="Centro de Custo..."
                :optionsList="lista_centro_custo"
                optionsData="id_centro_custo"
                :edicao="( filtro.id_unidade_operacao && !isNaN(filtro.id_unidade_operacao) ) ? true : false"
                v-model="filtro.id_centro_custo" />
          </div>
        </div>

        <div class="form-row mt-2">
          <div class="col col-12 col-md-4">
            <az-input
              placeholder="Categoria..."
              icon="fas fa-quote-left fa-fw"
              type="autocomplete"
              optionsMode="aql"
              service="categorias.index"
              optionsName="categoria.index.lancamentos"
              optionsData="id_categoria"
              optionsDisplay="search"
              :optionsParm="{ lancamento: true }"
              v-model="filtro.id_categoria">
            </az-input>
          </div>
          <div class="col col-12 col-md-8">
            <az-input
                placeholder="Pesquisa por # + número da baixa ou L + número do lançamento..." 
                icon="fa fa-search fa-fw" 
                v-model="filtro.search">
              <template v-slot:buttonposb>
                <div class="input-group-append">
                  <button class="btn btn-outline-primary" type="button" @click="incluir_lancamento()" v-if="pode_editar">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </button>
                  <button class="btn btn-outline-secondary" type="button" @click="show_obs = !show_obs" title="Exibir observações.">
                    <i class="fa-solid fa-comment-slash fa-fw" v-if="!show_obs"></i>
                    <i class="fa-solid fa-comment fa-fw" v-else></i>
                  </button>

                  <button class="btn btn-outline-danger" type="button" @click="cancelando = !cancelando" v-if="pode_editar && parametros && ( parametros.natureza == 'C' || parametros.natureza == 'D' )">
                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                  </button>
                </div>
                <print-export printid="extrato-de-conta" :left="true" :dados="dadosFormatados" model_type="baixa" />
              </template>
            </az-input>
          </div>
        </div>
      </div>
    </div>

    <div class="progress mt-1 mb-3">
      <div class="indeterminate" v-if="$store.state.loading && dados"></div>
      <div class="determinate" v-else></div>
    </div>

    <template v-if="dados && ( lista.length || ( saldo && !filtro.search ) )">

      <div v-if="parametros && !cancelando" class="alert alert-info d-flex justify-content-between small">
        <div>
          <div>Período ({{ parametros.tipo }}): {{ $util.getFormatDate(parametros.inicio) }} a {{ $util.getFormatDate(parametros.fim) }}</div>
          <div v-if="parametros.unidade">Unidade: {{ parametros.unidade.st_nome }}</div>
          <div v-if="parametros.conta">Conta: {{ parametros.conta.search }}</div>
        </div>
        <div>
          <div v-if="parametros.natureza">
            {{ parametros.conciliado == 'T'
              ? 'Transferência'
              : ( parametros.conciliado == 'C' ? 'Recebido' : 'Pago' )
            }}
          </div>
          <div v-if="parametros.conciliado">
            {{ parametros.conciliado == 'C' ? 'Conciliado' : 'Não Conciliado' }}
          </div>
        </div>
      </div>

      <div v-if="parametros && cancelando" class="alert alert-danger">
        Cancelando...
      </div>

      <div id="extrato-de-conta">
        <div class="d-none d-print-block mt-3">
          <h4>{{ $store.state.unidade.st_nome_fantasia }}</h4>
          <h3>Extrato de Conta</h3>
          <div class="alert alert-secondary mb-3">
            <div v-if="parametros">Período: ({{ parametros.tipo }}) {{ $util.getFormatDate(parametros.inicio) }} a {{ $util.getFormatDate(parametros.fim) }}</div>
            <div
              v-if="filtro.natureza"
            >{{ filtro.natureza == 'C' ? 'Recebido' : ( filtro.natureza == 'D' ? 'Pago' : filtro.natureza ) }}</div>
            <div v-if="filtro.search">Pesquisa: {{ filtro.search }}</div>
            <div v-if="parametros.unidade">
              Unidade: {{ parametros.unidade.st_nome }}
            </div>
            <div v-else-if="parametros.conta && parametros.conta.unidade_operacao">
              Unidade: {{ parametros.conta.unidade_operacao.st_nome }}
            </div>
            <div v-if="parametros.conta">
              <div>{{ parametros.conta.st_conta }}</div>
              <div>
                <span v-if="parametros.conta.dados_bancarios && parametros.conta.dados_bancarios.banco">
                  Banco: {{ parametros.conta.dados_bancarios.banco.search }}
                </span>
                <span v-if="parametros.conta.dados_bancarios && parametros.conta.dados_bancarios.in_agencia">
                  /
                  Agência: {{ parametros.conta.dados_bancarios.in_agencia }}
                </span>
                <span v-if="parametros.conta.dados_bancarios && parametros.conta.dados_bancarios.in_conta">
                  /
                  Conta: {{ parametros.conta.dados_bancarios.in_conta }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <table class="table table-hover table-responsive-md bg-white small cabecalho-fixo">
          <thead>
            <tr>
              <th>{{ ( parametros && parametros.tipo_data == 'V' ) ? 'Vencimento' : 'Baixa' }}</th>
              <th>Descrição</th>
              <th v-if="false">Competência</th>
              <th>Categoria</th>
              <th>Conta</th>
              <table-th title="Valor" v-model="ordem" sortby="valor_liquido" align="text-right"></table-th>
              <th class="text-right" v-if="!tem_filtro">Saldo</th>
              <th class="text-center">
                <button type="button" class="btn btn-outline-primary btn-sm d-print-none" @click="marcar_todos()" v-if="pode_editar">
                  Todos
                </button>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!tem_filtro && ( parametros && !parametros.tipo_data )">
              <td>{{ $util.getFormatDate(saldo.data) }}</td>
              <td>Saldo Inicial</td>
              <td colspan="3"></td>
              <td
                class="text-right"
                :class="saldo.inicial == 0 ? 'secondary' : ( saldo.inicial >= 0 ? 'text-primary' : 'text-danger' )"
              >{{ $util.formatMoeda (saldo.inicial) }}</td>
            </tr>

            <template v-for="(item, idx) in lista">

              <tr :key="idx" v-if="true">
                <td>{{ ( parametros && parametros.tipo_data == 'V' ) ? $util.getFormatDate(item.lancamento.dt_vencimento) : $util.getFormatDate(item.dt_baixa) }}</td>
                <td>
                  <span v-if="item.descricao">
                    <a href="#" @click.prevent="item.expandido = !item.expandido" class="card-link" v-if="item.expandido !== null">
                      <i class="fa-regular fa-square-plus mr-3" v-if="!item.expandido"></i>
                      <i class="fa-regular fa-square-minus mr-3" v-else></i>
                    </a>
                    <span class="badge badge-secondary mr-2" v-if="item.baixas.length > 1">
                      {{ item.baixas.length }}
                    </span>
                    {{ item.descricao }}

                    <a href="#" @click.prevent="editar_lancamento(item.lancamento)" class="card-link ml-2" v-if="item.tipo == 'B'">
                      #{{ item.lancamento.id_lancamento }}
                    </a>
                  </span>

                  <template v-else>
                    <span v-if="item.lancamento.fornecedor">
                      {{ item.lancamento.fornecedor.search }}
                      <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                    </span>
                    {{ item.lancamento.st_descricao }}
                    <span class="badge badge-secondary ml-1" v-if="item.lancamento.in_parcela">
                      {{ item.lancamento.in_parcela }}/{{ item.lancamento.in_total_parcelas }}
                    </span>
                    <span v-if="item.lancamento.st_doc" class="text-muted">
                    / {{ item.lancamento.st_doc }}
                    </span>
                    <a href="#" @click.prevent="editar_lancamento(item.lancamento)" class="card-link ml-2">
                      #{{ item.lancamento.id_lancamento }}
                    </a>
                  </template>

                  <div v-if="show_obs && item.lancamento.st_observacoes" class="text-muted">
                    {{ item.lancamento.st_observacoes }}
                  </div>
                </td>
                <td v-if="false">{{ $util.getFormatDate(item.lancamento.dt_competencia, 'MMM/YYYY') }}</td>
                <td>
                  <span v-if="item.lancamento">{{ item.lancamento.categorias }}</span>
                </td>
                <td>{{ item.conta.st_conta }}
                  <div v-if="item.lancamento && item.lancamento.conta_origem && item.lancamento.conta_origem.id_conta != item.conta.id_conta" class="text-muted small">
                    <i class="fa fa-exchange mr-2" aria-hidden="true"></i>
                    {{ item.lancamento.conta_origem.st_conta }}
                  </div>
                  <div v-if="item.lancamento && item.lancamento.conta_destino && item.lancamento.conta_destino.id_conta != item.conta.id_conta" class="small text-muted">
                    <i class="fa fa-exchange mr-2" aria-hidden="true"></i>
                    {{ item.lancamento.conta_destino.st_conta }}
                  </div>
                </td>
                <td
                  class="text-right text-nowrap"
                  :class="item.fator < 0 ? 'text-danger' : 'text-success'"
                >
                  {{ $util.formatMoeda (item.valor_liquido) }}
                  <i
                    class="fa fa-plus-circle text-success ml-1"
                    aria-hidden="true"
                    v-if="item.fator > 0"
                  ></i>
                  <i class="fa fa-minus-circle text-danger ml-1" aria-hidden="true" v-else></i>
                </td>
                <td class="text-right" v-if="!tem_filtro"
                  :class="item.saldo == 0 ? 'secondary' : ( item.saldo >= 0 ? 'text-primary' : 'text-danger' )">
                  {{ $util.formatMoeda (item.saldo) }}
                </td>

                <!-- Seleção -->
                <td v-if="!pode_editar"></td>

                <td  class="text-center" v-else-if="cancelando">
                  <input type="checkbox" v-model="item.check"/>
                </td>

                <td  class="text-center" v-else>
                  <!-- Parcialmente Conciliado -->
                  <span title="Lançamento parcialmente conciliado." v-if="item.fl_conciliado === 'P'">
                    <i class="fa-solid fa-square text-primary" v-if="!conciliando"></i>
                  </span>

                  <!-- Conciliado -->
                  <span :title="'Lançamento conciliado. (' + (item.st_memo_extrato ? item.st_memo_extrato : 'manual') + ')'" v-else-if="item.fl_conciliado">
                    <template v-if="showCheckboxType === 'checkbox'">
                      <input type="checkbox" v-model="item.check" style="width: 14px; height: 14px;" />
                    </template>
                    <template v-else>
                      <a href="#" @click.prevent="conciliarItem(item)">
                        <i class="fas fa-check-square" style="font-size: 16px;"></i>
                      </a>
                    </template>
                    <span class="ml-2" v-if="parametros.conciliado" title="Data da Conciliação">
                      {{ $util.getFormatDate(item.dt_conciliacao) }}
                    </span>
                  </span>

                  <!-- Não Conciliado -->
                  <span title="Lançamento não conciliado." v-else>
                    <!-- <a href="#" @click.prevent="conciliarItem(item)">
                      <i class="far fa-square"></i>
                    </a> -->
                    <input type="checkbox" v-model="item.check" style="width: 14px; height: 14px;" />
                  </span>
                </td>
              </tr>

              <template v-if="item.expandido">
                <!-- Detalhes da Baixa Múltipla -->
                  <tr v-for="(detalhe, idtx) in item.baixas" :key="'E' + idx + '.' + idtx" class="table-secondary">
                    <td></td>
                    <td>
                      {{ detalhe.lancamento.descricao_extrato }}
                      <a href="#" @click.prevent="editar_lancamento(detalhe.lancamento)" class="card-link ml-2">
                        #{{ detalhe.lancamento.id_lancamento }}
                      </a>
                    </td>
                    <td v-if="false">{{ $util.getFormatDate(detalhe.lancamento.dt_competencia, 'MMM/YYYY') }}</td>
                    <td>
                      <template v-if="detalhe.lancamento.ch_tipo_lancamento == 'T'">Transferência</template>
                      <template v-else-if="detalhe.lancamento.ch_tipo_lancamento == 'M'">Adiantamento</template>
                      <template v-else>{{ detalhe.lancamento.categorias ? detalhe.lancamento.categorias : "" }}</template>
                    </td>
                    <td>{{ detalhe.conta.st_conta }}
                      <div v-if="detalhe.lancamento && detalhe.lancamento.conta_origem && detalhe.lancamento.conta_origem.id_conta != detalhe.conta.id_conta" class="text-muted small">
                        <i class="fa fa-exchange mr-2" aria-hidden="true"></i>
                        {{ detalhe.lancamento.conta_origem.st_conta }}
                      </div>
                      <div v-if="detalhe.lancamento && detalhe.lancamento.conta_destino && detalhe.lancamento.conta_destino.id_conta != detalhe.conta.id_conta" class="small text-muted">
                        <i class="fa fa-exchange mr-2" aria-hidden="true"></i>
                        {{ detalhe.lancamento.conta_destino.st_conta }}
                      </div>
                    </td>
                    <td class="text-right">{{ $util.formatMoeda(detalhe.valor_liquido) }}</td>
                    <td v-if="!tem_filtro"></td>
                    <td>
                      <template v-if="!cancelando">
                        <span :title="'Lançamento conciliado. (' + (detalhe.st_memo_extrato ? detalhe.st_memo_extrato : 'manual') + ')'" v-if="detalhe.fl_conciliado">
                          <a href="#" @click.prevent="conciliarItem(detalhe)">
                            <i class="fas fa-check-square"></i>
                          </a>
                        </span>
                        <span title="Lançamento não conciliado." v-else>
                          <a href="#" @click.prevent="conciliarItem(detalhe)">
                            <i class="far fa-square"></i>
                          </a>
                        </span>
                      </template>
                    </td>
                  </tr>
              </template>
            </template>
          </tbody>

          <tfoot v-if="parametros.natureza && parametros.natureza != 'T' && parametros.natureza != 'M' && !cancelando">
            <tr>
              <td colspan="4">Total</td>
              <th
                class="text-right"
                :class="parametros.natureza == 'D' ? 'text-danger' : 'text-success'"
              >{{ $util.formatMoeda (total_lancamentos) }}</th>
            </tr>
          </tfoot>
        </table>

        <table class="table table-hover table-sm table-responsive-md bg-white"
          style="page-break-inside: avoid;"
          v-if="!cancelando && lista && lista.length">
          <tbody>
            <tr v-if="!tem_filtro && !view">
              <td>
                <a href="#" @click.prevent="parametros.detalhe_si = !parametros.detalhe_si">
                  <i class="fa-regular fa-square-plus fa-fw mr-2" v-if="!parametros.detalhe_si"></i>
                  <i class="fa-regular fa-square-minus fa-fw mr-2" v-else></i>
                </a>
                Saldo Inicial
              </td>
              <td class="text-right">
                {{ $util.formatMoeda (saldo.inicial) }}
                <i class="fas fa-circle text-primary fa-fw ml-2"></i>
              </td>
            </tr>
            <!-- Detalhe dos Saldos -->
            <template v-if="parametros.detalhe_si">
              <tr class="table-secondary" v-for="(conta, icx) in parametros.contas" :key="icx">
                <td>
                  <i class="fa-regular fa-square-caret-right fa-fw mr-2"></i>
                  <span class="small">
                    {{ conta.search }}
                  </span>
                </td>
                <td class="text-right">
                  <span class="small" :class="conta.saldos.saldo < 0 ? 'text-danger' : 'text-success'">
                    {{ $util.formatMoeda(conta.saldos.saldo) }}
                  </span>
                </td>
              </tr>
            </template>
            <template v-if="tem_filtro && !view && dados.current_page > 1">
              <tr>
                <td>
                  Páginas anteriores:
                </td>
                <td class="text-right">
                  {{ $util.formatMoeda (total_paginas_anteriores) }}
                  <i class="fas fa-circle text-primary fa-fw ml-2"></i>
                </td>
              </tr>
            </template>
            <tr v-if="parametros.natureza != 'D'">
              <td>Créditos</td>
              <td class="text-right">
                {{ $util.formatMoeda (total_creditos) }}
                <i class="fa fa-plus-circle text-success fa-fw ml-2"></i>
              </td>
            </tr>
            <tr v-if="parametros.natureza != 'C'">
              <td>Débitos</td>
              <td class="text-right">
                {{ $util.formatMoeda (total_debitos) }}
                <i class="fa fa-minus-circle text-danger fa-fw ml-2"></i>
              </td>
            </tr>
            <tr v-if="!tem_filtro && !tipo_data && !view">
              <td>Saldo Final</td>
              <td class="text-right">
                {{ $util.formatMoeda (saldo_final) }}
                <i class="fas fa-circle text-primary fa-fw ml-2"></i>
              </td>
            </tr>
            <tr v-else-if="!view && ( dados.current_page > 1 || ( parametros.natureza != 'C' && parametros.natureza != 'D' ) )">
              <td>Resultado</td>
              <td class="text-right">
                {{ $util.formatMoeda (total_creditos - total_debitos + total_paginas_anteriores) }}
                <i class="fa-solid fa-equals fa-fw ml-2 text-primary"></i>
              </td>
            </tr>
          </tbody>
        </table>

        <br><br><br><br><br>

        <pre v-if="false">{{ parametros }}</pre>
      </div>

      <pre v-if="1 == 0">{{ dados }}</pre>
    </template>

    <template v-else>
      <az-empty-state />
    </template>

    <nav class="navbar fixed-bottom navbar-light bg-light" v-if="cancelando && lista_cancela.length > 0">
        <div class="navbar-brand">
          Selecionado:
          {{ $util.formatMoeda(total_cancelemnto) }}
          <span class="badge badge-secondary ml-2">{{lista_cancela.length }}</span>
        </div>
        <div class='mr-3'>
          <button class="btn btn-danger btn-sm ml-1 mt-1 mb-1" type="button" @click="cancelar_baixas ()">
              Cancelar Baixas
          </button>
        </div>
    </nav>

      <nav class="navbar fixed-bottom navbar-light bg-light" v-if="!cancelando && conciliando">
          <div class="navbar-brand">
            <template v-if="filtro.conciliacao === 'C'">
              Itens para desconciliar: {{conciliar_itens.length }} / R$ {{ $util.formatMoeda(total_selecionado) }}
            </template>
            <template v-else>
              Itens para conciliar: {{conciliar_itens.length }} / R$ {{ $util.formatMoeda(total_selecionado) }}
            </template>
          </div>
          <div class='mr-3'>
            <div class="row">
              <template v-if="filtro.conciliacao !== 'C'">
                <span class="mt-2 mr-2">Data da conciliação:</span>
                <az-input
                  class="mr-4"
                  type="date"
                  v-model="data_conciliacao_todos"
                />
              </template>
                <button 
                  v-if="parametros.conta && parametros.conta.st_convenio && !filtro.conciliacao" 
                  class="btn btn-secondary btn-sm ml-1 mt-1 mb-1" 
                  type="button" 
                  @click="gerar_cnab()">
                  Gerar CNAB
                </button>
              <button class="btn btn-danger btn-sm ml-1 mt-1 mb-1" type="button" @click="marcar_todos_cancelar ()">
                  Cancelar
              </button>
              <button class="btn btn-success btn-sm ml-1 mt-1 mb-1" type="button" @click="conciliar_desconciliar_todos ()">
                <template v-if="filtro.conciliacao === 'C'">
                  Desconciliar
                </template>
                <template v-else>
                  {{ conciliar_itens.length > 1 ? "Conciliar Todos" : "Conciliar" }}
                </template>
              </button>
            </div>
          </div>
      </nav>

    <!-- Paginação -->
    <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-else-if="dados && dados.last_page > 1">
        <div class="d-flex">
            <paginate
                class="mb-0"
                :page-count="dados.last_page"
                :container-class="'pagination'"
                :page-class="'page-item'"
                :page-link-class="'page-link'"
                :prev-class="'page-link'"
                :next-class="'page-link'"
                :prev-text="'<<'"
                :next-text="'>>'"
                :click-handler="paginar">
            </paginate>
        </div>
    </nav>

    <!-- Lançamento -->
    <edicao-lancamento ref="lancamento" @refresh="load()" :viewonly="!pode_editar"/>

    <!-- Modal Cancelamento de Baixa em Lote -->
    <div class="modal fade" id="cancelaBaixasModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Cancelar Baixas</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="alert alert-danger">
              <strong>Essa ação é irreversível.</strong>
              <div>
                Total: {{ $util.formatMoeda(total_cancelemnto) }}
              </div>
              <div>
                Quantidade: {{ lista_cancela.length }}
              </div>
            </div>

            <az-input
              label="Motivo"
              required
              :validate="validate"
              v-model="motivo_cancela" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit color="danger" @click="efetivar_cancelar_baixas()">Efetivar Cancelamento</az-submit>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de conciliar -->
    <div
      class="modal fade"
      id="conciliarModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="conciliar">
          <div class="modal-header">
            <h5 class="modal-title">
              {{conciliar.conciliado ? "Conciliar Baixa" : "Informações da conciliação"}}
              <span v-if="conciliar.baixa && conciliar.baixa.id_baixa_multipla" title="Baixa Múltipla." class="badge badge-secondary ml-3">
                BM #{{ conciliar.baixa.id_baixa_multipla }}
              </span>
              <span v-else-if="conciliar.baixa && conciliar.baixa.id_baixa" title="Baixa" class="badge badge-secondary ml-3">
                #{{ conciliar.baixa.id_baixa }}
              </span>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col col-12 col-md-12">
                <az-input label="Descrição" :edicao="false" v-model="conciliar.descricao" />
              </div>
            </div>
            <div class="row">
              <div class="col col-12">
                <az-input label="Conta" :edicao="false" v-model="conciliar.conta" />
              </div>

            </div>
            <div class="row">
              <div class="col col-12 col-md-6">
                <az-input label="Valor" type="money" :edicao="false" v-model="conciliar.valor" />
              </div>
              <div class="col col-12 col-md-6">
                <az-input label="Valor Líquido" type="money" :edicao="false" v-model="conciliar.liquido" />
              </div>
            </div>
            <div class="row">
              <div class="col col-12 col-md-12">
                <az-input
                  type="date"
                  label="Data conciliação"
                  :validate="validate"
                  :edicao="!conciliar.conciliado"
                  required
                  v-model="conciliar.data"
                />
              </div>
            </div>
            <div class="row">
              <div class="col col-12 col-md-12">
                <az-input
                  label="Número"
                  :edicao="!conciliar.conciliado"
                  v-model="conciliar.checknum"
                />
              </div>
            </div>
            <div class="row">
              <div class="col col-12 col-md-12">
                <az-input
                  label="Observações"
                  :edicao="!conciliar.conciliado"
                  v-model="conciliar.memo"
                />
              </div>
            </div>
            <div class="row">
              <div class="col col-12 col-md-12">
                <az-input
                  label="Identificador da transação"
                  :edicao="!conciliar.conciliado"
                  v-model="conciliar.fitid"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit v-if="!conciliar.conciliado" @click="conciliarItemSalvar ()">Salvar</az-submit>
            <button
              v-else
              type="button"
              class="btn btn-danger ml-2"
              @click.prevent="removerConciliacao()"
            >Remover conciliação</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as moment from "moment";
import _ from "lodash";
import $ from "jquery";
import AzInput from "../../shared/forms/AzInput.vue";
import AzSubmit from "../../util/AzSubmit.vue";
import AzEmptyState from "../../util/AzEmptyState.vue";
import PrintExport from "../../shared/PrintExport.vue";
import EdicaoLancamento from './EdicaoLancamento.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import TableTh from '../../shared/table/TableTh.vue';

export default {
  data() {
    return {
      filtroExibicao: {
        concilicao: '',
      },
      isLoading: false,
      showCheckboxType: 'checkbox',
      referencia: this.$util.hoje().substr(0, 7),
      filtro: {
        id_conta: "",
        search: "",
        natureza: "",
        conciliacao: "",
        id_unidade_operacao: "",
        id_centro_custo: "", 
        inicio: "",
        fim: "",
        periodo: "do",
        consolidado: false,
        tipo_filtro_unidade: 'L'
      },
      cancelando: false,
      dados: null,
      saldo: null,
      parametros: null,
      conciliar: null,
      validate: false,
      montando: true,
      selecionados: null,
      data_conciliacao_todos: null,
      from: "",
      to: "",
      tipo_data: '',
      page: 1,
      motivo_cancela: "", 
      ordem: "", 
      show_obs: false, 
    };
  },
  components: {
    AzInput,
    AzEmptyState,
    AzSubmit,
    PrintExport,
    EdicaoLancamento,
    AzPeriodo,
    TableTh, 
  },

  props: ["parms", "block_redir", "view", "fluxo"],

  computed: {
    lista_centro_custo: function () { 
        if ( !this.filtro.id_unidade_operacao )
            return [];

        let unidade = this.$store.state.unidade.unidade_operacaos
            .find(item => item.id_unidade_operacao == this.filtro.id_unidade_operacao);

        if ( unidade )
            return unidade.centro_custos;

        return [];
    },

    pode_editar: function () { 
      if ( this.view || !this.parametros ) { 
        return false;
      }

      if ( this.parametros && !this.parametros.acesso_edicao ) { 
        return false;
      }

      return true;
    },

    conciliar_itens: function() {
      if (this.filtro.conciliacao === 'C') {
        return this.lista.filter(item => item.fl_conciliado && !item.check);
      } else {
        return this.lista.filter(item => !item.fl_conciliado && item.check);
      }
    },

    conciliando: function() {
      if (this.isLoading) return false;
      
      if (this.filtro.conciliacao === 'C') {
        return this.lista.some(item => item.fl_conciliado && !item.check);
      } else {
        return this.lista.some(item => !item.fl_conciliado && item.check);
      }
    },

    dadosFormatados: function () {
      return this.lista.map((item) => {
        return {
          data: this.$util.getFormatDate(item.dt_baixa),
          descricao: item.lancamento.st_descricao,
          competencia: this.$util.getFormatDate(
            item.lancamento.dt_competencia,
            "MMM/YYYY"
          ),
          categoria:
            item.lancamento.ch_tipo_lancamento == "T"
              ? "Transferência"
              : ( item.lancamento.ch_tipo_lancamento == "M"
                ? 'Adiantamento'
                : _.get(item, 'lancamento.categorias') ),
          conta: item.conta.st_conta,
          para: ( ( item.lancamento && item.lancamento.conta_origem && item.lancamento.conta_origem.id_conta != item.conta.id_conta )
            ? item.lancamento.conta_origem.st_conta
            : '' )
            +
            ( ( item.lancamento && item.lancamento.conta_destino && item.lancamento.conta_destino.id_conta != item.conta.id_conta )
              ? item.lancamento.conta_destino.st_conta
              : ''
            ),
          valor: this.$util.formatMoeda(item.valor_liquido),
          fator: item.fator,
          saldo: !this.tem_filtro ? this.$util.formatMoeda(item.saldo) : "",
          fornecedor: item.lancamento.fornecedor ? item.lancamento.fornecedor.search : "",
          doc: item.lancamento.st_doc,
        };
      });
    },

    lista: function () {
      if (!this.dados) return [];

      let pesquisar = this.filtro.search.trim();
      let parts = pesquisar.replace(" ", ".*");
      let match = parts;
      let reg = new RegExp(match, "i");
      let parcial = this.saldo.inicial;

      let lista = this.dados.data
        .filter(item => !item.fl_conciliado || !this.cancelando)
        .filter((item) => {
          return (
            (!this.filtro.search || reg.test(JSON.stringify(item)))
          );

          /*&&
            (!this.filtro.natureza ||
              ( this.filtro.natureza == 'T' && item.lancamento.ch_tipo_lancamento == 'T' ) ||
              (item.lancamento.categoria &&
                item.lancamento.categoria.ch_natureza ==
                  this.filtro.natureza)) &&
            (!this.filtro.conciliacao ||
              (item.fl_conciliado && this.filtro.conciliacao == "C") ||
              (!item.fl_conciliado && this.filtro.conciliacao == "N"))
          );
          */
        })
        .sort((a, b) => {
          let data_a = this.tipo_data == 'V' ? a.lancamento.dt_vencimento : a.dt_baixa;
          let data_b = this.tipo_data == 'V' ? b.lancamento.dt_vencimento : b.dt_baixa;

          if ( !data_a || !data_b )
            return 1;

          return (data_a.substr(0,10) == data_b.substr(0,10) ? ( a.id_baixa > b.id_baixa ? 1 :  -1 ) : ( data_a > data_b ? 1 : -1 ) );
        })
        .map((item) => {
          parcial = parcial + item.valor_liquido * (item.fator < 0 ? -1 : 1);
          item.saldo = parcial;
          return item;
        });

      if ( this.ordem ) { 
        lista = _.orderBy(
          lista, 
          this.ordem.name,
          this.ordem.direction 
        );
      }

      return lista;
    },

    lista_cancela: function () {
      if ( !this.cancelando )
        return [];

      return this.lista.filter(item => item.check);
    },

    total_cancelemnto: function () {
      return this.lista.filter(item => item.check)
        .reduce((total, item) => {
          return (total = total + item.valor_liquido);
        }, 0);
    },

    tem_filtro: function () {
      return (
        this.filtro.search || this.parametros.natureza || this.parametros.conciliacao || this.parametros.tipo_data || this.ordem 
      ) || ( this.dados && this.dados.current_page > 9999 );
    },

    total_lancamentos: function () {
      return this.lista.reduce((total, item) => {
        return (total = total + item.valor_liquido);
      }, 0);
    },

    total_creditos: function () {
      return this.lista.filter(item => item.fator > 0)
        .reduce((total, item) => {
          return (total = total + item.valor_liquido);
        }, 0);
    },

    total_debitos: function () {
      return this.lista.filter(item => item.fator < 0)
        .reduce((total, item) => {
          return (total = total + item.valor_liquido);
        }, 0);
    },

    total_paginas_anteriores: function () {
      if ( !this.parametros.natureza )
        return 0;

      return ( this.parametros && this.parametros.contas )
        ? this.parametros.contas.reduce((total, item) => {
            let campo = this.parametros.natureza == 'C' ? 'saldos.entradas_mov_page' : 'saldos.saidas_mov_page';

            if ( this.parametros.natureza == 'T' || this.parametros.natureza == 'M' ) {
              return total = total + parseFloat(_.get(item, 'saldos.entradas_mov_page', 0))
                + parseFloat(_.get(item, 'saldos.saidas_mov_page', 0));
            } else {
              return total = total + parseFloat(_.get(item, campo, 0));
            }

          }, 0)
        : 0;
    },

    saldo_final: function () {
      let ultimo = _.last(this.lista);
      return ultimo ? ultimo.saldo : 0;
    },

        total_selecionado: function() {
      return this.conciliar_itens.reduce((total, item) => {
        return total + item.valor_liquido;
      }, 0);
    },
  },

  methods: {
        marcar_todos() {
      const isConciliados = this.filtro.conciliacao === 'C';
      this.lista.forEach(item => {
        if ((isConciliados && item.fl_conciliado) || (!isConciliados && !item.fl_conciliado)) {
          item.check = !item.check;
        }
      });
    },

    marcar_todos_cancelar() {
    this.lista.forEach(item => {
    item.check = false;
      });
    },
    
    efetivar_cancelar_baixas () {
      this.$util.atualizar(this, {
        service: 'financeiro',
        func: 'cancelar_baixas',
        dados: {
          baixas: this.lista_cancela,
          st_motivo_cancelamento: this.motivo_cancela,
        },
        modal: "cancelaBaixasModal",
        toast: true,
        reload: true,
      });
    },

    cancelar_baixas () {
      this.validate = false;
      this.motivo_cancela = "";

      $('#cancelaBaixasModal').modal('show');
    },

    paginar (page) {
        this.page = page;
        this.load(false);
    },

    ajustar_fim () {
        if ( this.from )
            this.to = this.from;
    },

    incluir_lancamento () {
      this.$refs.lancamento.incluir(true, this.filtro.id_conta);
    },

    editar_lancamento (item) {
      this.$refs.lancamento.editar(item);
    },

    imprimir() {
      this.$htmlToPaper("extrato-de-conta", null, () => {
        console.log("Printing");
      });
    },

    load() {
      this.filtro.conciliacao = this.filtroExibicao.conciliacao;
      
      if (this.montando) return;

      this.isLoading = true;

      if (this.referencia) {
        if (!this.from || !this.to || this.from > this.to) {
          this.dados = null;
          return;
        }
      }

      this.showCheckboxType = this.filtro.conciliacao === 'C' ? 'checkbox' : 'icon';
      
      this.cancelando = false;

      this.$util.setCookie('ext-bm-cons', this.filtro.consolidado ? 'S' : 'N');

      this.$util.load(this, {
        service: "financeiro",
        func: "extrato",
        parms: {
          referencia: this.referencia,
          tipo_data: this.tipo_data,
          ...this.filtro,
          fluxo: this.fluxo,
          size: 1000,
        },
        page: this.page,
        loadTo: (res) => {
          this.dados = res.items;
          this.saldo = res.saldo;
          this.parametros = res.parametros;

        if (this.filtro.conciliacao === 'C') {
        this.dados.data.forEach(item => {
        if (item.fl_conciliado) {
            item.check = true;
              }
            });
          }

          this.showCheckboxType = this.filtro.conciliacao === 'C' ? 'checkbox' : 'icon';

          this.isLoading = false;

          if ( this.page > 1 && res.items.last_page < res.items.current_page ) {
            this.page = 1;

            this.$nextTick(() => {
              this.load();
            });
          }
        },
      });
    },

    conciliarItem(baixa) {
      if ( this.view ) {
        return;
      }

      this.conciliar = null;
      const data = {
        descricao: baixa.lancamento.st_descricao,
        conta: baixa.conta.st_conta,
        valor: baixa.dc_valor,
        liquido: baixa.valor_liquido,
        data: baixa.dt_conciliacao,
        checknum: baixa.st_conciliacao_checknum,
        memo: baixa.st_memo_extrato,
        fitid: baixa.st_conciliacao_fitid,
        conciliado: baixa.fl_conciliado,
        baixa: { check: true, ...baixa },
      };
      this.validate = false;
      this.$nextTick(() => {
        this.conciliar = data;
        $("#conciliarModal").modal("show");
      });
    },
    conciliarItemSalvar() {
      this.$util.atualizar(this, {
        service: "financeiro",
        func: "conciliar_baixa",
        modal: "conciliarModal",
        dados: {
          baixas: [
            {
              ...this.conciliar.baixa,
              check: true
            }
          ],
          fitid: this.conciliar.fitid,
          memo: this.conciliar.memo,
          data_conciliacao: this.conciliar.data,
          checknum: this.conciliar.checknum,
        },
        reload: true,
        callback: (res) => {
          if (res && res.original.status_code >= 400) {
            this.$toast.add({
              severity: "error",
              summary: "Conciliação",
              detail: res ? res.original.msg : "Erro ao conciliar baixa.",
              life: 5000,
            });
          } else {
            this.$toast.add({
              severity: "success",
              summary: "Conciliação",
              detail: "Conciliação realizada com sucesso.",
              life: 3000,
            });
          }
        },
      });
    },
    removerConciliacao() {
      this.$util.atualizar(this, {
        service: "financeiro",
        func: "remover_conciliar_baixa",
        modal: "conciliarModal",
        dados: {
          baixas: [this.conciliar.baixa],
        },
        toast: true,
        reload: true,
      });
    },

conciliar_desconciliar_todos() {
  const selecionados = this.conciliar_itens;
  
  if(selecionados.length === 0) return;
  
  if(this.filtro.conciliacao === 'C') {
    if(!confirm("Deseja realmente desconciliar os itens selecionados?")) return;
    
    this.$util.atualizar(this, {
      service: "financeiro",
      func: "remover_conciliar_baixa",
      dados: {
        baixas: selecionados.map(item => ({ ...item, check: true })),
        data_conciliacao: this.data_conciliacao_todos
      },
      toast: true,
      reload: true,
      callback: () => {
        this.marcar_todos_cancelar();
      }
    });
  } else {
    if(selecionados.length === 1) {
      this.conciliarItem(selecionados[0]);
      return;
    }
    
    if(!confirm("Deseja realmente conciliar os itens selecionados?")) return;
    
    this.$util.atualizar(this, {
      service: "financeiro",
      func: "conciliar_baixa",
      dados: {
        baixas: selecionados.map(item => ({ ...item, check: true })),
        fitid: "",
        memo: "Conciliação em lote",
        data_conciliacao: this.data_conciliacao_todos,
        checknum: "",
      },
      reload: true,
      callback: () => {
        this.marcar_todos_cancelar();
      }
    });
  }
},

      gerar_cnab() {
          console.log(this.parametros.conta)
          const selecionados = this.lista
              .filter(element => element.check == true)
              .map(({ id_baixa, conta }) => {
                return {
                    id_baixa,
                    id_conta: conta.id_conta,
                }
            });

            if (selecionados.length > 0) {
                let id_conta = selecionados[0].id_conta;
                let erro = false;
                selecionados.forEach(element => {
                    if (element.id_conta != id_conta) {
                        erro = true;
                    }
                });
    
                if (erro) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Conciliação",
                        detail: "Os itens selecionados não são da mesma conta.",
                        life: 5000,
                    });
                    return;
                }
            }

          this.$store.commit("loading", true);
          const query = {
              q: [
                  {
                      name: "financeiro.gerar_cnab",
                      id: "cnab",
                      parms: {
                          faturas: selecionados
                      }
                  }
              ]
          }

          this.axios.post('/aql', query)
              .then(res => {
                  if (res.data.cnab.status == 200) {
                      let downloadAnchorNode = document.createElement("a");
                      let dataStr =
                          "data:text/plain;charset=utf-8," +
                          encodeURIComponent(res.data.cnab.data.conteudo);
                      downloadAnchorNode.setAttribute("href", dataStr);
                      downloadAnchorNode.setAttribute("download", res.data.cnab.data.arquivo);
                      document.body.appendChild(downloadAnchorNode);
                      downloadAnchorNode.click();
                      downloadAnchorNode.remove();
                  }
              })
              .catch(() => {
                  this.$store.commit("loading", false);
              })
              .finally(() => {
                  this.$store.commit("loading", false);
              });

        console.log(selecionados)
    },

    preencher_parms (parms) {
      if (parms) {
        if (parms.mes) {
          this.referencia = parms.mes;
        }

        if (parms.natureza) {
          this.filtro.natureza = parms.natureza;
        }

        if (parms.categoria) {
          this.filtro.search = parms.categoria;
        }

        if (parms.id_categoria) {
          this.filtro.id_categoria = parms.id_categoria;
        }

        if ( parms.conciliado ) {
          this.filtro.conciliacao = 'C';
        }

        if ( parms.filtros ) {
          _.assign(this.filtro, parms.filtros);
        } else { 
          _.assign(this.filtro, parms);
        }

        if ( parms.mes == 'T' ) {
          this.referencia = "";
        } else if ( parms.mes ) {
          switch (parms.tempo) {
            case 'diario':
              this.filtro.periodo = "ld";
              this.filtro.inicio = parms.mes;
              break;

            default:
              this.filtro.periodo = "lm";
              break;
          }
          this.filtro.mes = parms.mes;

          this.referencia = parms.mes;
        }

      }

      if (this.referencia) {
        this.from = this.referencia + "-01";
        this.to = moment(this.referencia + "-01")
          .endOf("month")
          .format("YYYY-MM-DD");
      }
    }
  },

  created() {
    this.filtroExibicao = {
      conciliacao: this.filtro.conciliacao,
    };
    this.preencher_parms(this.parms);
  },

  beforeMount() {
    this.filtro.id_unidade_operacao = this.$store.state.user.id_unidade_operacao
      ? this.$store.state.user.id_unidade_operacao
      : this.$util.getCookie('id_unidade_operacao');

    this.filtro.consolidado = this.$util.getCookie('ext-bm-cons') == 'S' ? true : false;
  },

  mounted() {
    if ( !this.block_redir ) {

      this.$store.commit("setBreadcrumb", [
        { name: "Financeiro", path: "/financeiro" },
        { name: "Extrato de Contas", path: "/financeiro/extrato" },
      ]);

      if ( this.$route.path != '/financeiro/extrato' ) {
        this.$router.push({ path: '/financeiro/extrato' });
      }

    }

    this.$nextTick(() =>  {
      this.data_conciliacao_todos = this.$util.hoje();
      this.montando = false;

      if ( !this.fluxo ) { 
        this.load();
      }
    });
  },
};

</script>
